import HomeActions from './Home.actions';

const initialState = {
};

function HomeReducer (state = initialState, action) {
  const { type = '', payload = null } = { ...action };
  switch (type) {
    case HomeActions.SET_PASSED_SECTIONS: {
      return { ...state, ...payload };
    }

    default:
      return state;
  }
}

export default HomeReducer;
